<mat-menu class="mobile-menu-panel" #menu="matMenu">
  <ng-container *ngFor="let menuItem of menuItems">
    <a
      mat-menu-item
      *ngIf="
        menuItem.visible &&
        menuItem.routerLink &&
        menuItem.type == menuItemTypes.Normal
      "
      [matTooltipPosition]="'right'"
      matTooltipClass="tooltip-yellow"
      [matTooltip]="
        disabledLink(menuItem)
          ? 'You must be logged in to access this item.'
          : ''
      "
      [ngClass]="{
        'disabled-link': disabledLink(menuItem),
        'red bold': missingTrainings && menuItem.name == 'Procedure Training'
      }"
      [routerLink]="!disabledLink(menuItem) ? menuItem.routerLink : null"
      >{{ menuItem.name }}</a
    >
    <a
      mat-menu-item
      *ngIf="
        menuItem.visible &&
        !menuItem.isSeparator &&
        menuItem.route &&
        menuItem.type == menuItemTypes.Link
      "
      [matTooltipPosition]="'right'"
      matTooltipClass="tooltip-yellow"
      [matTooltip]="
        disabledLink(menuItem)
          ? 'You must be logged in to access this item.'
          : ''
      "
      [ngClass]="{ 'disabled-link': disabledLink(menuItem) }"
      target="_blank"
      href="{{ !disabledLink(menuItem) ? menuItem.route : null }}"
      >{{ menuItem.name }}</a
    >
    <button
      mat-menu-item
      *ngIf="menuItem.visible && menuItem.type == menuItemTypes.PopUp"
      [ngClass]="{ 'disabled-link': disabledLink(menuItem) }"
      (click)="
        !disabledLink(menuItem) ? openComponent(menuItem.route ?? '') : null
      "
    >
      {{ menuItem.name }}
    </button>
    <ng-container
      *ngIf="menuItem.visible && menuItem.type == menuItemTypes.Submenu"
    >
      <button mat-menu-item [matMenuTriggerFor]="sub.menu">
        {{ menuItem.name }}
      </button>
      <head-menu-mobile-submenu
        #sub
        [menuItem]="menuItem"
      ></head-menu-mobile-submenu>
    </ng-container>
    <hr class="separator" *ngIf="menuItem.type == menuItemTypes.Separator" />
  </ng-container>
</mat-menu>
